import { __assign } from "tslib";
import React, { createContext, useContext, useMemo, } from 'react';
import invariant from 'invariant';
import { getTranslateFn, } from '../../translation/translation';
var context = createContext(undefined);
export var VelocityPrivateContextProvider = function (_a) {
    var children = _a.children, translateFn = _a.translateFn;
    var providerValue = useMemo(function () { return ({
        translate: getTranslateFn(translateFn),
    }); }, [translateFn]);
    return React.createElement(context.Provider, { value: providerValue }, children);
};
export var VelocityPrivateContextConsumer = context.Consumer;
export var useVelocityPrivateContext = function () {
    var ctx = useContext(context);
    invariant(ctx !== undefined, 'VelocityPrivateContext not found. Did you forget to put the VelocityProvider?');
    return ctx;
};
export var withVelocityPrivateContext = function (Component) {
    return function (props) {
        var ctx = useVelocityPrivateContext();
        return (
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        React.createElement(Component, __assign({}, props, ctx)));
    };
};
//# sourceMappingURL=VelocityPrivateContext.js.map